module.exports = __webpack_public_path__ + "media/icons/favicons/favicon-32x32-afcebe35ae8710a6dc20bd3336f117d6.png";